import api from "./api";

export function scrapeWebsiteData() {
  return api.post("/scrape");
}

export function getLastScrapeInfo() {
  return api.get("/scrape/last");
}
